/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {CellHeader, CellBody, FormCell, Input, Label} from 'react-weui';


class LiveroomVerifyFormCell extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const {field, handleChange} = this.props;
        handleChange(field, e.target.value);
    }

    render() {
        const {label, placeholder, defaultValue, type = "text"} = this.props;
        return(
            <FormCell>
                <CellHeader>
                    <Label>{label}</Label>
                </CellHeader>
                <CellBody>
                    <Input type={type} placeholder={placeholder} onChange={this.handleChange} defaultValue={defaultValue}/>
                </CellBody>
            </FormCell>
        )
    }
}

export default LiveroomVerifyFormCell;


// WEBPACK FOOTER //
// ./src/components/liveroomVerify/LiveroomVerifyFormCell.js